export class MainTableFilterIdentification {
  moduleName: string;
  additional?: any;

  constructor(moduleName: string, additional?: any) {
    this.moduleName = moduleName;
    this.additional = additional;
  }
}
